/*
 * @Author: zl
 * @Date: 2022-03-30 16:56:59
 * @LastEditTime: 2022-04-27 09:21:28
 * @LastEditors: zl
 * @Description: 投资管理
 */
import request from '@/api/request'

/**
 * 东部新中心 - 投资管理 - 统计查询数据
 * 接口管理员： 郑志会
 */
export const getInvestmentManagePage = function (data) {
    return request({
        url: '/auditoutputvalue/getInvestmentManagePage',
        method: 'post',
        data,
    })
}

/**
 * 东部新中心 - 投资管理 - 查询列表数据
 * 接口管理员： 郑志会
 */
export const getInvestmentManage = function (data) {
    return request({
        url: 'auditoutputvalue/getInvestmentManage',
        method: 'post',
        data,
    })
}

/**
 * 东部新中心 - 投资管理 - 统计查询数据
 * 接口管理员： 郑志会
 */
export const getInvestmentTotalPage = function (data) {
    return request({
        url: '/auditoutputvalue/getInvestManageTotal',
        method: 'post',
        data,
    })
}